__turbopack_context__.v({
  "action": "BlogCta-module__xXfqWW__action",
  "container": "BlogCta-module__xXfqWW__container",
  "note": "BlogCta-module__xXfqWW__note",
  "text": "BlogCta-module__xXfqWW__text",
  "texts": "BlogCta-module__xXfqWW__texts",
  "title": "BlogCta-module__xXfqWW__title",
});
